import ChipCarousel from './ChipCarousel'

export default ChipCarousel
